import { render, staticRenderFns } from "./LiveEditorDialog.vue?vue&type=template&id=5f7c72de&scoped=true"
import script from "./LiveEditorDialog.vue?vue&type=script&lang=js"
export * from "./LiveEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./LiveEditorDialog.vue?vue&type=style&index=0&id=5f7c72de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7c72de",
  null
  
)

export default component.exports